import Navbar from "../components/ui/navbar";

const GuidePage = () => {
  return (
    <>
      <div className="relative flex-shrink-0 w-full py-8 border-b border-1">
        <Navbar />
      </div>
      <div className="container p-4 mx-auto">
        <div className="flex flex-col items-center gap-8 md:gap-8">
          <div className="max-w-4xl text-center">
            <p className="p-4 pb-2 text-2xl leading-tight border-b">
              LNPDB-MolCube Builder : Building Moderna LNP System with Quick
              Bilayer
            </p>
          </div>

          <div className="w-full max-w-6xl">
            <div className="w-full aspect-video">
              <iframe
                className="w-full h-full rounded-lg shadow-xl"
                src="https://www.youtube.com/embed/CL2RP8O-46w?si=SUTBEHd7mb1rKmpL"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuidePage;
